import { createContext } from "react";

export const ExercisesCounterContext = createContext(1);
